<fieldset>
  <legend [ngClass]="{'is-visually-hidden': labelHidden, 'is-required': required}">
    {{ labelTitle }} {{required ? '(' + ('forms.mandatory' | translate) + ')' : ''}}
  </legend>

  <div class="c__radio-group">
    @for (item of items; track item) {
      <div class="c__radio {{item.checked ? 'is-checked' : ''}}">
        @if (!item.showPaymentMethods) {
          <input
            type="radio"
            [name]="nameField"
            [id]="'radio-'+uuidInput + '_' + $index"
            [value]="item.value"
            [disabled]="item.disabled || disabled"
            [checked]="item.checked"
            (click)="setOption(item)"
          >
          <label
            [for]="'radio-'+uuidInput + '_' + $index"
            (keydown)="onKeyUp($event, item)"
            [class]="item?.type ? 'c__radio-delivery' : '' "
          >
            @if (item?.type) {
              <sd-icon [name]="'icon-delivery-' + item.type" />
            }
            <span class="c__libelle is-medium">
              {{ item.libelle }}
              @if (applyDescriptionHidden ? (item.description && item.showDescription) : item.description) {
                <span class="c__description">
                  {{ item.description }}
                </span>
              }
            </span>
            @if (item.media) {
              <sd-banner [isFit]="true" [media]="item.media" />
            }
            @if (item.additionalText) {
              <span class="c__additional-text is-body-s is-semi-bold">
                {{ item.additionalText }}
              </span>
            }
          </label>
          @if (item.checked) {
            <ng-container [ngTemplateOutlet]="selectedForm" />
          }
        } @else {
          <ng-content select="[sd-payment-methods]" />
        }
      </div>
    }
  </div>

  <ng-content select="[message]" />

  <ng-template #selectedForm>
    <ng-content />
  </ng-template>

</fieldset>
